// ─── PRIVACY POLICY & TERMS ───────────────────────────────────────────────────
import React from 'react';
import { useNavigate } from 'react-router-dom';

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#FFD166', marginBottom: 12 }}>
        {title}
      </h2>
      <div style={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.8, fontSize: '0.9rem' }}>
        {children}
      </div>
    </div>
  );
}

export default function PrivacyPage({ lang }) {
  const navigate = useNavigate();
  const isAr = lang === 'ar';

  return (
    <div className="page" dir={isAr ? 'rtl' : 'ltr'} style={{ fontFamily: isAr ? "'Tajawal', sans-serif" : "'Outfit', sans-serif" }}>
      <nav>
        <div className="nav-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <div className="logo" style={{ fontSize: '1.2rem' }}>MyGlow<span className="logo-dot">.me</span></div>
        </div>
        <div className="nav-right">
          <button className="btn btn-ghost" style={{ fontSize: '0.8rem', padding: '8px 14px' }} onClick={() => navigate('/')}>
            {isAr ? '← الرئيسية' : '← Home'}
          </button>
        </div>
      </nav>

      <div style={{ maxWidth: 680, margin: '0 auto', padding: '40px 24px 80px' }}>
        <h1 style={{
          fontFamily: isAr ? "'Tajawal', sans-serif" : "'Playfair Display', serif",
          fontSize: '2rem', fontWeight: 700, color: '#FFD166', marginBottom: 8
        }}>
          {isAr ? 'سياسة الخصوصية والشروط' : 'Privacy Policy & Terms'}
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.8rem', marginBottom: 40 }}>
          {isAr ? 'آخر تحديث: مايو ٢٠٢٦' : 'Last updated: May 2026'}
        </p>

        {isAr ? (
          <>
            <Section title="ما البيانات اللي بنجمعها؟">
              <p>بنجمع البيانات دي بس:</p>
              <ul style={{ paddingRight: 20, marginTop: 8 }}>
                <li><strong>اسمك وإيميلك</strong> — لما بتعمل حساب. بنستخدمهم لإدارة الحساب وإرسال إشعارات.</li>
                <li><strong>الرسايل اللي بتتبعتلك</strong> — مجهولة تماماً، مش بنربطها بالمُرسِل.</li>
                <li><strong>الصورة الشخصية (اختياري)</strong> — لو حبيت تضيف صورة لبروفايلك.</li>
                <li><strong>تفضيلات الاستخدام</strong> — زي اللغة المختارة (بتتحفظ على جهازك بس).</li>
              </ul>
            </Section>
            <Section title="بنستخدم البيانات إزاي؟">
              <p>بنستخدم البيانات بس عشان:</p>
              <ul style={{ paddingRight: 20, marginTop: 8 }}>
                <li>نوصّلك الرسايل اللي بيبعتهالك صحابك.</li>
                <li>نبعتلك إيميل إشعار لما تيجيك رسالة جديدة (لو اخترت كده).</li>
                <li>نحافظ على سلامة المنصة ونمنع المحتوى الضار.</li>
              </ul>
              <p style={{ marginTop: 12 }}>مش بنبيع بياناتك لحد. مش بنستخدمها في إعلانات.</p>
            </Section>
            <Section title="مين بيشوف إيه؟">
              <ul style={{ paddingRight: 20 }}>
                <li><strong>الرسايل:</strong> بتشوفها إنت بس. مش ممكن حد تاني يشوفها.</li>
                <li><strong>البروفايل العام:</strong> اسمك وصورتك وبيو — مرئيين للعموم لو اخترت تفعيل البروفايل العام.</li>
                <li><strong>الصور الشخصية:</strong> بتتخزن في سيرفر آمن، لكن الرابط بتاعها عام. متبعتيش صور حساسة.</li>
              </ul>
            </Section>
            <Section title="الخدمات الخارجية">
              <p>بنستخدم:</p>
              <ul style={{ paddingRight: 20, marginTop: 8 }}>
                <li><strong>Supabase</strong> — قاعدة البيانات والمصادقة. (أمريكا)</li>
                <li><strong>Vercel</strong> — استضافة الموقع. (أمريكا)</li>
                <li><strong>Resend</strong> — إرسال الإيميلات. (أمريكا)</li>
                <li><strong>Google Fonts</strong> — الخطوط. ممكن يحفظ كوكيز خارجية.</li>
              </ul>
            </Section>
            <Section title="حقوقك">
              <p>تقدر في أي وقت:</p>
              <ul style={{ paddingRight: 20, marginTop: 8 }}>
                <li>تحذف حسابك وكل بياناتك من إعدادات البروفايل.</li>
                <li>تعدّل اسمك وبيانات بروفايلك.</li>
                <li>تتواصل معنا على: <strong>hello@myglow.me</strong></li>
              </ul>
            </Section>
            <Section title="الكوكيز">
              <p>بنستخدم كوكيز ضرورية بس للجلسة وتفضيلات اللغة. بنستخدم Google Fonts اللي ممكن يحفظ كوكيز خاصة بيه — دا الوحيد اللي بيجي من طرف تالت.</p>
            </Section>
          </>
        ) : (
          <>
            <Section title="What data do we collect?">
              <p>We collect only what's necessary:</p>
              <ul style={{ paddingLeft: 20, marginTop: 8 }}>
                <li><strong>Your name and email</strong> — when you sign up. Used for account management and notifications.</li>
                <li><strong>Messages sent to your jar</strong> — completely anonymous. We do not link them to the sender.</li>
                <li><strong>Your profile photo (optional)</strong> — if you choose to add one.</li>
                <li><strong>Language preference</strong> — stored locally on your device only.</li>
              </ul>
            </Section>
            <Section title="How do we use it?">
              <p>We use your data only to:</p>
              <ul style={{ paddingLeft: 20, marginTop: 8 }}>
                <li>Deliver messages your friends send you.</li>
                <li>Send you an email notification when a new glow arrives (if you've opted in).</li>
                <li>Keep the platform safe and moderate harmful content.</li>
              </ul>
              <p style={{ marginTop: 12 }}>We never sell your data. We never use it for advertising.</p>
            </Section>
            <Section title="Who can see what?">
              <ul style={{ paddingLeft: 20 }}>
                <li><strong>Your messages:</strong> Only you. No one else can read your jar.</li>
                <li><strong>Your public profile:</strong> Your name, photo, and bio are public if you enable a public profile.</li>
                <li><strong>Profile photos:</strong> Stored securely but accessible via URL. Don't upload sensitive images.</li>
              </ul>
            </Section>
            <Section title="Third-party services">
              <p>We use the following services to operate MyGlow.me:</p>
              <ul style={{ paddingLeft: 20, marginTop: 8 }}>
                <li><strong>Supabase</strong> — database and authentication (USA)</li>
                <li><strong>Vercel</strong> — web hosting (USA)</li>
                <li><strong>Resend</strong> — transactional email (USA)</li>
                <li><strong>Google Fonts</strong> — typography (may set third-party cookies)</li>
              </ul>
            </Section>
            <Section title="Your rights">
              <p>You can at any time:</p>
              <ul style={{ paddingLeft: 20, marginTop: 8 }}>
                <li>Delete your account and all associated data from your Profile settings.</li>
                <li>Edit or update your name and profile information.</li>
                <li>Contact us at <strong>hello@myglow.me</strong> for any data requests.</li>
              </ul>
            </Section>
            <Section title="Cookies">
              <p>We use only essential session cookies and your language preference (stored locally). Google Fonts may set its own third-party cookies — that's the only external cookie source we use.</p>
            </Section>
          </>
        )}

        <div style={{
          marginTop: 48, padding: '20px 24px',
          background: 'rgba(255,209,102,0.06)',
          border: '1px solid rgba(255,209,102,0.15)',
          borderRadius: 12,
          color: 'rgba(255,255,255,0.5)', fontSize: '0.8rem', lineHeight: 1.7
        }}>
          {isAr
            ? 'باستخدامك لـ MyGlow.me، بتوافق على السياسة دي. لو عندك سؤال، تواصل معنا على hello@myglow.me'
            : 'By using MyGlow.me, you agree to this policy. Questions? Reach us at hello@myglow.me'}
        </div>
      </div>
    </div>
  );
}
